export function windowProvider(): Window { return window; }
